import AutospageApp from './Autospage';

export default AutospageApp;
